import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'
import Checkbox from '../../../UI/Checkbox'
import { Loader } from '../../../UI'

class Activities extends Component {
  constructor(props) {
    super(props)

    this.state = {
      categories: [],
      categoryNames: []
    }
    this.toggleCategory = this.toggleCategory.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps.currentState)
  }

  toggleCategory(event) {
    const { categories, categoryNames } = this.state
    let index

    if (event.target.checked) {
      categories.push(event.target.id)
      categoryNames.push(event.target.value)
    } else {
      index = categories.indexOf(event.target.id)
      categories.splice(index, 1)
      categoryNames.splice(index, 1)
    }

    this.setState(
      {
        categories: categories,
        categoryNames: categoryNames
      },
      () => this.props.updateState(this.state)
    )
  }

  componentWillUnmount() {
    this.props.updateState(this.state)
  }

  render() {
    const { t } = this.props
    return (
      <div className="activities">
        <h2 className="section-title">{t('things_during_stay')}</h2>

        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6 checkbox-column">
            <Checkbox
              handleChange={this.toggleCategory}
              checked={this.state.categories.includes('Museums')}
              value={t('categories:Museums')}
              id="Museums"
            >
              {t('categories:Museums')}
            </Checkbox>
            <Checkbox
              handleChange={this.toggleCategory}
              checked={this.state.categories.includes('HistoricalSites')}
              value={t('categories:HistoricalSites')}
              id="HistoricalSites"
            >
              {t('categories:historical_sites')}
            </Checkbox>
            <Checkbox
              handleChange={this.toggleCategory}
              checked={this.state.categories.includes('ArtFairsGalleries')}
              value={t('categories:ArtFairsGalleries')}
              id="ArtFairsGalleries"
            >
              {t('categories:ArtFairsGalleries')}
            </Checkbox>
            <Checkbox handleChange={this.toggleCategory} checked={this.state.categories.includes('Hiking')} value={t('hiking')} id="Hiking">
              {t('hiking')}
            </Checkbox>
            <Checkbox
              handleChange={this.toggleCategory}
              checked={this.state.categories.includes('Shrines')}
              value={t('categories:Shrines')}
              id="Shrines"
            >
              {t('categories:Shrines')}
            </Checkbox>
            <Checkbox
              handleChange={this.toggleCategory}
              checked={this.state.categories.includes('Temples')}
              value={t('categories:Temples')}
              id="Temples"
            >
              {t('categories:Temples')}
            </Checkbox>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6 checkbox-column">
            <Checkbox
              handleChange={this.toggleCategory}
              checked={this.state.categories.includes('FoodAndDrink')}
              value={t('categories:FoodAndDrink')}
              id="FoodAndDrink"
            >
              {t('categories:FoodAndDrink')}
            </Checkbox>
            <Checkbox
              handleChange={this.toggleCategory}
              checked={this.state.categories.includes('Gardens')}
              value={t('categories:Gardens')}
              id="Gardens"
            >
              {t('categories:Gardens')}
            </Checkbox>
            <Checkbox
              handleChange={this.toggleCategory}
              checked={this.state.categories.includes('Castles')}
              value={t('categories:Castles')}
              id="Castles"
            >
              {t('categories:Castles')}
            </Checkbox>
            <Checkbox handleChange={this.toggleCategory} checked={this.state.categories.includes('Nature')} value={t('nature')} id="Nature">
              {t('Nature')}
            </Checkbox>
            <Checkbox
              handleChange={this.toggleCategory}
              checked={this.state.categories.includes('AmusementParks')}
              value={t('categories:AmusementParks')}
              id="AmusementParks"
            >
              {t('categories:AmusementParks')}
            </Checkbox>
            <Checkbox
              handleChange={this.toggleCategory}
              checked={this.state.categories.includes('Festivals')}
              value={t('categories:Festivals')}
              id="Festivals"
            >
              {t('categories:Festivals')}
            </Checkbox>
          </div>
        </div>
      </div>
    )
  }
}

const enhance = compose(translate('booking_steps'))

export default enhance(Activities)



// WEBPACK FOOTER //
// src/components/Guru/BookingSteps/Steps/Activities.jsx